import EllipsisText from 'components/EllipsisText';
import { DataCellProps } from '../types';
import { Box } from '@mui/material';

export const TeamNameCell = ({ team }: DataCellProps) => {
  return (
    <Box textAlign={'left'}>
      <EllipsisText text={team.name || ''} width={'180px'}>
        {team.name}
      </EllipsisText>
    </Box>
  );
};
